(function () {
  var toggle = document.getElementById('navToggle');
  var links = document.getElementById('navLinks');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
    });
  }

  var COPY = "You're on the list — we'll email when kits open. No spam.";
  var CAPTCHA_HINT = "Please complete the verification check to join the list.";

  function cleanPostedParam() {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('customer_posted')) {
        u.searchParams.delete('customer_posted');
        history.replaceState({}, '', u.pathname + u.search + (u.hash || '#notify'));
      }
    } catch (e) {}
  }

  function showWaitlistInline(msg, isError) {
    var card = document.getElementById('notify');
    if (!card) return;
    var existing = document.getElementById('mnWaitlistInline');
    if (existing) existing.remove();
    var form = document.getElementById('notifyForm');
    var el = document.createElement('div');
    el.id = 'mnWaitlistInline';
    el.className = 'mn-waitlist-inline' + (isError ? ' is-error' : ' is-ok');
    el.setAttribute('role', isError ? 'alert' : 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<p class="mn-waitlist-inline__text"></p>';
    el.querySelector('.mn-waitlist-inline__text').textContent = msg || COPY;
    if (!isError && form) {
      form.setAttribute('hidden', 'hidden');
      form.style.display = 'none';
    }
    // Place right under the card intro / where the form was
    if (form && form.parentNode === card) {
      card.insertBefore(el, form.nextSibling);
    } else {
      card.appendChild(el);
    }
    try { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    if (!isError) cleanPostedParam();
  }

  function pinHcaptchaChallenge() {
    var iframes = document.querySelectorAll('iframe[src*="hcaptcha"][src*="challenge"], iframe[title*="hCaptcha challenge"]');
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];
      var box = iframe.parentElement;
      if (!box) continue;
      var shell = box;
      for (var d = 0; d < 4 && shell && shell !== document.body; d++) {
        var st = window.getComputedStyle(shell);
        var rect = shell.getBoundingClientRect();
        var offscreen = rect.bottom < 0 || rect.top > window.innerHeight || rect.top < -500 || Math.abs(rect.top) > 5000;
        if (st.position === 'fixed' || st.position === 'absolute' || offscreen) {
          shell.style.setProperty('position', 'fixed', 'important');
          shell.style.setProperty('top', '0', 'important');
          shell.style.setProperty('left', '0', 'important');
          shell.style.setProperty('right', '0', 'important');
          shell.style.setProperty('bottom', '0', 'important');
          shell.style.setProperty('width', '100%', 'important');
          shell.style.setProperty('height', '100%', 'important');
          shell.style.setProperty('max-width', '100vw', 'important');
          shell.style.setProperty('max-height', '100vh', 'important');
          shell.style.setProperty('transform', 'none', 'important');
          shell.style.setProperty('inset', '0', 'important');
          shell.style.setProperty('z-index', '2147483646', 'important');
          shell.style.setProperty('display', 'flex', 'important');
          shell.style.setProperty('align-items', 'center', 'important');
          shell.style.setProperty('justify-content', 'center', 'important');
          shell.style.setProperty('overflow', 'visible', 'important');
        }
        shell = shell.parentElement;
      }
      iframe.style.setProperty('z-index', '2147483647', 'important');
      iframe.style.setProperty('visibility', 'visible', 'important');
      iframe.style.setProperty('opacity', '1', 'important');
    }
  }

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { pinHcaptchaChallenge(); });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'src', 'title'] });
  }
  setInterval(pinHcaptchaChallenge, 800);

  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var marker = document.querySelector('[data-mn-waitlist-ok]');
    if (params.get('customer_posted') === 'true' || marker) {
      showWaitlistInline(marker ? marker.textContent.trim() : COPY, false);
    }

    var form = document.getElementById('notifyForm');
    if (!form) return;
    form.addEventListener('submit', function () {
      setTimeout(function () {
        pinHcaptchaChallenge();
        if (!document.getElementById('notifyForm')) return;
        var resp = form.querySelector('[name="h-captcha-response"], textarea[name="h-captcha-response"]');
        var token = resp && resp.value;
        if (!token) {
          showWaitlistInline(CAPTCHA_HINT, true);
          pinHcaptchaChallenge();
        }
      }, 700);
    }, true);
  });
})();
